<script setup>
import { computed, inject } from 'vue';

import { useInstructorStore } from '@/stores/InstructorStore'

import {  cleanUrl, stripHtml } from '@/helpers/text'

// import instructor1Img from '@/assets/images/placeholders/instructor-2.png';
// import instructor2Img from '@/assets/images/placeholders/instructor-3.png';
// import instructor3Img from '@/assets/images/placeholders/instructor-4.png';
// import instructor4Img from '@/assets/images/placeholders/instructor-5.png';

const siteConfig = inject('siteConfig')

const instructorStore = useInstructorStore()

const instructors = computed(() => {
  return instructorStore.instructorsForInstructorPage
  // const list = []

  // instructorStore.instructors.forEach(instructor => {
  //   let item = {
  //     id: instructor.instructorId,
  //     image: instructor,
  //     name: 'Clinton Mcclure',
  //     job: 'Art director',
  //     description:
  //       'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque autem dolorum dolore amet incidunt quibusdam beatae a quos illum',
  //     social: {
  //       twitter: 'https://www.twitter.com',
  //       facebook: 'https://www.facebook.com',
  //       dribbble: 'https://www.dribbble.com',
  //     },
  //   }
    
  //   list.push(item)
  // })  
})

// const instructors = ref([
//   {
//     id: 'DenUCtWH89',
//     image: instructor1Img,
//     name: 'Clinton Mcclure',
//     job: 'Art director',
//     description:
//       'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque autem dolorum dolore amet incidunt quibusdam beatae a quos illum',
//     social: {
//       twitter: 'https://www.twitter.com',
//       facebook: 'https://www.facebook.com',
//       dribbble: 'https://www.dribbble.com',
//     },
//   },
//   {
//     id: 'hHwMWJ0fxh',
//     image: instructor2Img,
//     name: 'Daryl Nehls',
//     job: 'Instructor',
//     description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
//     social: {
//       twitter: 'https://www.twitter.com',
//       dribbble: 'https://www.dribbble.com',
//     },
//   },
//   {
//     id: 'GD6CdyRNRP',
//     image: instructor3Img,
//     name: 'Rayford Chenail',
//     job: 'Art director',
//     description:
//       'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque autem dolorum dolore amet incidunt quibusdam beatae a quos illum',
//     social: {
//       twitter: 'https://www.twitter.com',
//       facebook: 'https://www.facebook.com',
//       dribbble: 'https://www.dribbble.com',
//     },
//   },
//   {
//     id: 'VIAFPupaWb',
//     image: instructor4Img,
//     name: 'Clinton Mcclure',
//     job: 'Instructor',
//     description: 'Lorem ipsum dolor sit amet.',
//     social: {
//       dribbble: 'https://www.dribbble.com',
//     },
//   },
// ]);
</script>

<template>
  <section class="store-instructors">
    <div class="hero-banner" :style="`background-image: url(/sites/${siteConfig.key}/${siteConfig.assets?.banners?.instructors})`">
      <div class="container">
        <h1>Instructors</h1>
      </div>
    </div>

    <div v-if="instructorStore.loadingInstructors" class="h-[calc(100vh-280px)] md:h-[calc(100vh-320px)] xl:h-[calc(100vh-385px)] flex justify-center items-center">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="150px" height="150px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" class="fill-accent-1" stroke="none">
          <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"></animateTransform>
        </path>
      </svg>
    </div>

    <div v-else class="container">
      <div class="page-info">
        <h1 class="page-heading">Instructors at {{ siteConfig.org.name }}</h1>
        <!-- <p class="page-description">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque autem
          dolorum dolore amet incidunt quibusdam beatae a quos illum, odit
          doloribus qui repudiandae aut veritatis commodi? Magnam, unde
          deleniti! Eius optio consequuntur eos.
        </p> -->
      </div>

      <div class="instructors-cards">
        <div
          class="instructor-card"
          v-for="(instructor, index) in instructors"
          :key="index"
        >
          <router-link
            :to="'/instructors/' + instructor.instructorId"
          >
            <img
              v-lazy="instructor.imageUrl"
              :alt="`${instructor.fullName} Profile Image`"
            />
          </router-link>
          <h2 class="xlarge-text" v-html="instructor.fullName"></h2>
          <!-- <span class="small-regular" v-html="instructor.job"></span> -->
          <!-- <p v-html="truncateHtml(instructor.bio, 150)"></p> -->
          <p v-html="stripHtml(instructor.bio)"></p>
          <ul class="!mb-0">
            <li v-if="instructor.website">
              <a
                :href="cleanUrl(instructor.website)"
                class="website"
                target="_blank"
              >
                <Icon icon="akar-icons:link-chain" class="icon" />
              </a>
            </li>
            <li v-if="instructor.social?.twitter">
              <a
                :href="instructor.social.twitter"
                class="twitter"
                target="_blank"
              >
                <Icon icon="akar-icons:twitter-fill" class="icon" />
              </a>
            </li>
            <li v-if="instructor.social?.facebook">
              <a
                :href="instructor.social.facebook"
                class="facebook"
                target="_blank"
              >
                <Icon icon="brandico:facebook" class="icon" />
              </a>
            </li>
            <li v-if="instructor.social?.dribbble">
              <a
                :href="instructor.social.dribbble"
                class="dribbble"
                target="_blank"
              >
                <Icon icon="akar-icons:dribbble-fill" class="icon" />
              </a>
            </li>
          </ul>
          <router-link
            :to="'/instructors/' + instructor.instructorId"
            class="link btn-accent-1"
          >
            Learn More
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url('./index.pcss');
</style>
